// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file legebill/site/v4/site.proto (package legebill.site.v4, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { NarrativeType } from "../../type/narrative_type_pb";
import { file_legebill_type_narrative_type } from "../../type/narrative_type_pb";
import type { DirectTimelinePostPreference, RoundingPreference } from "../../../wisetime/type/site_preferences_pb";
import { file_wisetime_type_site_preferences } from "../../../wisetime/type/site_preferences_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file legebill/site/v4/site.proto.
 */
export const file_legebill_site_v4_site: GenFile = /*@__PURE__*/
  fileDesc("ChtsZWdlYmlsbC9zaXRlL3Y0L3NpdGUucHJvdG8SEGxlZ2ViaWxsLnNpdGUudjQiHAoOR2V0U2l0ZVJlcXVlc3QSCgoCaWQYASABKAki3gIKBFNpdGUSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRJGChZwb3N0X3RpbWVfcmVxdWlyZW1lbnRzGAMgASgLMiYubGVnZWJpbGwuc2l0ZS52NC5Qb3N0VGltZVJlcXVpcmVtZW50cxI+Cg9wb3N0X3RpbWVfcHJlZnMYBCABKAsyJS5sZWdlYmlsbC5zaXRlLnY0LlBvc3RUaW1lUHJlZmVyZW5jZXMSHwoXcm91bmRpbmdfcHJlZmVyZW5jZV9zZWMYByABKAUSLQoJc2l0ZV9tb2RlGAggASgOMhoubGVnZWJpbGwuc2l0ZS52NC5TaXRlTW9kZRJHChhzaXRlX3JvdW5kaW5nX3ByZWZlcmVuY2UYBiABKA4yIS53aXNldGltZS50eXBlLlJvdW5kaW5nUHJlZmVyZW5jZUICGAFKBAgFEAZSFWRlZmF1bHRfYWN0aXZpdHlfdHlwZSJKChRQb3N0VGltZVJlcXVpcmVtZW50cxIUCgx0YWdfcmVxdWlyZWQYASABKAhKBAgCEANSFmFjdGl2aXR5X3R5cGVfcmVxdWlyZWQioQEKE1Bvc3RUaW1lUHJlZmVyZW5jZXMSNAoObmFycmF0aXZlX3R5cGUYASABKA4yHC5sZWdlYmlsbC50eXBlLk5hcnJhdGl2ZVR5cGUSVAofZGlyZWN0X3RpbWVsaW5lX3Bvc3RfcHJlZmVyZW5jZRgCIAEoDjIrLndpc2V0aW1lLnR5cGUuRGlyZWN0VGltZWxpbmVQb3N0UHJlZmVyZW5jZSpCCghTaXRlTW9kZRIZChVTSVRFX01PREVfVU5TUEVDSUZJRUQQABIOCgpQUk9EVUNUSU9OEAESCwoHU0FOREJPWBACMlIKC1NpdGVTZXJ2aWNlEkMKB0dldFNpdGUSIC5sZWdlYmlsbC5zaXRlLnY0LkdldFNpdGVSZXF1ZXN0GhYubGVnZWJpbGwuc2l0ZS52NC5TaXRlQi4KGGNvbS5sZWdlYmlsbC5hcGkuc2l0ZS52NEIQU2l0ZVNlcnZpY2VQcm90b1ABYgZwcm90bzM", [file_legebill_type_narrative_type, file_wisetime_type_site_preferences]);

/**
 * @generated from message legebill.site.v4.GetSiteRequest
 */
export type GetSiteRequest = Message<"legebill.site.v4.GetSiteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message legebill.site.v4.GetSiteRequest.
 * Use `create(GetSiteRequestSchema)` to create a new message.
 */
export const GetSiteRequestSchema: GenMessage<GetSiteRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_v4_site, 0);

/**
 * @generated from message legebill.site.v4.Site
 */
export type Site = Message<"legebill.site.v4.Site"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: legebill.site.v4.PostTimeRequirements post_time_requirements = 3;
   */
  postTimeRequirements?: PostTimeRequirements;

  /**
   * @generated from field: legebill.site.v4.PostTimePreferences post_time_prefs = 4;
   */
  postTimePrefs?: PostTimePreferences;

  /**
   * @generated from field: int32 rounding_preference_sec = 7;
   */
  roundingPreferenceSec: number;

  /**
   * @generated from field: legebill.site.v4.SiteMode site_mode = 8;
   */
  siteMode: SiteMode;

  /**
   * Deprecated, use rounding_preference_sec instead
   *
   * @generated from field: wisetime.type.RoundingPreference site_rounding_preference = 6 [deprecated = true];
   * @deprecated
   */
  siteRoundingPreference: RoundingPreference;
};

/**
 * Describes the message legebill.site.v4.Site.
 * Use `create(SiteSchema)` to create a new message.
 */
export const SiteSchema: GenMessage<Site> = /*@__PURE__*/
  messageDesc(file_legebill_site_v4_site, 1);

/**
 * @generated from message legebill.site.v4.PostTimeRequirements
 */
export type PostTimeRequirements = Message<"legebill.site.v4.PostTimeRequirements"> & {
  /**
   * @generated from field: bool tag_required = 1;
   */
  tagRequired: boolean;
};

/**
 * Describes the message legebill.site.v4.PostTimeRequirements.
 * Use `create(PostTimeRequirementsSchema)` to create a new message.
 */
export const PostTimeRequirementsSchema: GenMessage<PostTimeRequirements> = /*@__PURE__*/
  messageDesc(file_legebill_site_v4_site, 2);

/**
 * @generated from message legebill.site.v4.PostTimePreferences
 */
export type PostTimePreferences = Message<"legebill.site.v4.PostTimePreferences"> & {
  /**
   * @generated from field: legebill.type.NarrativeType narrative_type = 1;
   */
  narrativeType: NarrativeType;

  /**
   * @generated from field: wisetime.type.DirectTimelinePostPreference direct_timeline_post_preference = 2;
   */
  directTimelinePostPreference: DirectTimelinePostPreference;
};

/**
 * Describes the message legebill.site.v4.PostTimePreferences.
 * Use `create(PostTimePreferencesSchema)` to create a new message.
 */
export const PostTimePreferencesSchema: GenMessage<PostTimePreferences> = /*@__PURE__*/
  messageDesc(file_legebill_site_v4_site, 3);

/**
 * @generated from enum legebill.site.v4.SiteMode
 */
export enum SiteMode {
  /**
   * @generated from enum value: SITE_MODE_UNSPECIFIED = 0;
   */
  SITE_MODE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRODUCTION = 1;
   */
  PRODUCTION = 1,

  /**
   * @generated from enum value: SANDBOX = 2;
   */
  SANDBOX = 2,
}

/**
 * Describes the enum legebill.site.v4.SiteMode.
 */
export const SiteModeSchema: GenEnum<SiteMode> = /*@__PURE__*/
  enumDesc(file_legebill_site_v4_site, 0);

/**
 * Resources of the Site service API include:
 *
 * - sites/*
 *
 * @generated from service legebill.site.v4.SiteService
 */
export const SiteService: GenService<{
  /**
   * Retrieve site info.
   *
   * Possible failures:
   *
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:         The site could not be found
   * - PERMISSION_DENIED: User is not a member of the site
   *
   * @generated from rpc legebill.site.v4.SiteService.GetSite
   */
  getSite: {
    methodKind: "unary";
    input: typeof GetSiteRequestSchema;
    output: typeof SiteSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_legebill_site_v4_site, 0);

